// extracted by mini-css-extract-plugin
module.exports = {"depJobTabs":"DepartmentJob_depJobTabs__NxEuO","tabsPills":"DepartmentJob_tabsPills__J_GFb","tabsItems":"DepartmentJob_tabsItems__25fm4","tabsLink":"DepartmentJob_tabsLink__31J_f"};